import React from "react";

import { StyleSheet, TouchableOpacity, Text, Platform } from "react-native";

import ImageComponent from "./ImageComponent";
import AppTheme from "../AppTheme";
import { MoodColors } from "./mood/MoodsHelper";

export default function ManaButton(props) {
  const {
    text,
    style,
    styleText,
    image,
    icon,
    onPress = () => {},
    disabled,
    hideShadow = false,
    isMainButton = false,
    isDangerButton = false,
    isLinkButton = false,
  } = props;

  const shadowStyle = !hideShadow
    ? {
        shadowOpacity: 0.1,
        shadowOffset: {
          width: 0,
          height: 4,
        },
        shadowColor: "#000",
        shadowRadius: 5,
      }
    : {};

  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.button,
        isMainButton ? {} : styles.secondaryButton,
        isDangerButton ? styles.dangerButton : {},
        isLinkButton ? styles.linkButton : {},
        shadowStyle,
        style,
        disabled ? styles.disabled : {},
      ]}
      disabled={disabled}
    >
      {image ? <ImageComponent image={image} style={styles.buttonBg} /> : null}
      {icon ? <ImageComponent image={icon} style={styles.icon} /> : null}
      <Text
        style={[
          styles.buttonText,
          isMainButton ? {} : styles.secondaryButtonText,
          isDangerButton ? styles.dangerButtonText : {},
          styleText,
          disabled ? styles.disabledText : {},
        ]}
      >
        {text}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    position: "relative",
    width: 300,
    height: 44,
    paddingHorizontal: 8,
    borderRadius: 4,
    elevation: 5,
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",

    maxWidth: "100%",
    backgroundColor: AppTheme.DEFAULT_COLOR,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#FFF",
    textAlign: "center",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  secondaryButton: {
    backgroundColor: "#F4F6FA",
  },
  secondaryButtonText: {
    color: AppTheme.DEFAULT_COLOR,
  },
  linkButton: Platform.select({
    ios: {
      backgroundColor: "transparent",
    },
    android: {
      backgroundColor: "transparent",
    },
    web: {
      backgroundColor: "transparent",
    boxShadow: "none",
    },
  }),
  dangerButton: {
    backgroundColor: MoodColors.VeryBad,
  },
  dangerButtonText: {
    color: "#FFF",
  },
  buttonBg: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: 35,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 10,
  },
  disabled: {
    backgroundColor: "#8B92A1",
  },
  disabledText: {
    color: "#DDDAD5",
  },
});
